import React, { Component } from "react";
import "./form-field.style.scss";
import moment from "moment";
import { DATE_FORMAT } from "../helper";

const formatNumber = (input) => {
  return Number((+input).toFixed(2)).toLocaleString("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
};

export default class RenderFormFieldView extends Component {
  render() {
    const { name, type, label, options, formValues, isFormatNumber } =
      this.props;

    if (type === "space") return null;
    if (type === "button") return null;

    const value = (() => {
      const val = formValues[name];

      if (type === "input-number") {
        if (isFormatNumber === true) {
          return formatNumber(val);
        }
      }

      if (type === "dropdown") {
        const selected = options.find((op) => op.value === val) || {};
        return selected.label;
      }

      if (type === "datePicker") {
        if (!val) return "-";
        // Try DD/MM/YYYY first (app format stored by RenderFormField)
        let m = moment(val, "DD/MM/YYYY", true);
        if (m.isValid()) return m.format(DATE_FORMAT);
        // Fallback: YYYY-MM-DD (HTML date input native)
        m = moment(val, "YYYY-MM-DD", true);
        return m.isValid() ? m.format(DATE_FORMAT) : val;
      }

      return val;
    })();

    return (
      <div className="form-view-field">
        <dt>{label}</dt>
        <dl>{value || "-"}</dl>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// src/pages/Pricing/NewPricing/components/RenderFormFieldView.js